var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 4.15823C13.9991 3.45641 13.5043 2.33496 12.8941 2.33496C12.2838 2.33496 11.7891 3.45645 11.7891 4.15823C11.7891 4.7656 12.1598 5.27271 12.6552 5.39839V8.35792H13.133V5.39835C13.6283 5.27271 13.9991 4.76568 13.9991 4.15823Z",
    fill: "#AD916F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 7.37402H13.3168V11.1722C13.3168 11.4053 13.1278 11.5942 12.8947 11.5942C12.6617 11.5942 12.4727 11.4053 12.4727 11.1722V7.37402H12.4727Z",
    fill: "url(#paint0_linear_284_25124)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08036 2.46777C1.94841 2.46777 1.84144 2.57474 1.84144 2.70669V4.40798C1.84144 4.60744 1.675 4.7697 1.47046 4.7697H1.39856V2.73233C1.39856 2.60038 1.29159 2.49341 1.15964 2.49341C1.02769 2.49341 0.920722 2.60038 0.920722 2.73233V4.7697H0.848822C0.644276 4.7697 0.477834 4.60744 0.477834 4.40798V2.70677C0.477834 2.57483 0.370865 2.46786 0.238917 2.46786C0.106969 2.46786 0 2.57483 0 2.70677V4.40806C0 4.87097 0.38075 5.24766 0.848822 5.24766H0.920722V8.35928C0.920722 8.49122 1.02769 8.59819 1.15964 8.59819C1.29159 8.59819 1.39856 8.49122 1.39856 8.35928V5.24766H1.47046C1.93853 5.24766 2.31928 4.87101 2.31928 4.40806V2.70677C2.31928 2.57478 2.21231 2.46777 2.08036 2.46777Z",
    fill: "#AD916F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.737305 7.37402H1.58133V11.1722C1.58133 11.4053 1.39241 11.5942 1.15928 11.5942C0.926223 11.5942 0.737305 11.4053 0.737305 11.1722V7.37402Z",
    fill: "url(#paint1_linear_284_25124)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00068 11.6683C9.57802 11.6683 11.6674 9.579 11.6674 7.00165C11.6674 4.42431 9.57802 2.33496 7.00068 2.33496C4.42333 2.33496 2.33398 4.42431 2.33398 7.00165C2.33398 9.579 4.42333 11.6683 7.00068 11.6683Z",
    fill: "url(#paint2_linear_284_25124)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99102 7.00254C9.99102 8.65519 8.65128 9.99492 6.99864 9.99492C5.34599 9.99492 4.00625 8.65519 4.00625 7.00254C4.00625 5.34989 5.34599 4.01016 6.99864 4.01016C8.65128 4.01016 9.99102 5.34989 9.99102 7.00254Z",
    fill: "#AD916F",
    stroke: "#C4C4C4",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_25124",
    x1: 12.8947,
    y1: 7.37402,
    x2: 12.8947,
    y2: 11.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_25124",
    x1: 1.15932,
    y1: 7.37402,
    x2: 1.15932,
    y2: 11.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_25124",
    x1: 7.00068,
    y1: 2.33496,
    x2: 7.00068,
    y2: 11.6683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem5);
export default __webpack_public_path__ + "static/media/item5.e46ba95c669b6fd3112c3a54007a4806.svg";
export { ForwardRef as ReactComponent };